module.exports = __webpack_public_path__ + "img/sos-pare-brise-mobile.7fe4eea.jpg";